module.exports = __webpack_public_path__ + "static/media/PIBKG_grey.912239f5.png";